import script from "./notifications-popup.vue?vue&type=script&setup=true&lang=ts"
export * from "./notifications-popup.vue?vue&type=script&setup=true&lang=ts"

import "./notifications-popup.vue?vue&type=style&index=0&id=f8cadd70&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f8cadd70"]])

export default __exports__